import styled from 'styled-components';

const Container = styled.div`
  .ant-select .ant-select-selector {
    align-items: center;
    padding: 20px !important;
    width: 200px !important;
    height: 64px !important;
    position: relative;
    width: max-content;
    &:hover {
      cursor: pointer;
    }
  }
  .ant-select-selection-placeholder {
    display: flex;
  }
  .ant-select-selection-item {
    height: 100%;
    p {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 28px;
      font-size: 18px;
    }
  }
  .ant-select-item-option-content {
    p {
      font-size: 18px;
    }
  }
  .ant-select-arrow {
    right: 20px;
  }
  .ant-select-clear {
    right: 20px;
    img {
      opacity: 0;
      margin-top: -2px;
      transition: opacity 0.6s linear;
      width: 17px;
      height: 17px;
    }
    .show {
      opacity: 1;
    }
  }
`;

export { Container };
